import * as React from "react";
const SvgCheckboxIndeterminate = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<rect className="interior" x={1} y={1} width={20} height={20} rx={1} fill="white" /><path className="checkmark" d="M5 12V10H17V12H5Z" fill="#5B1DC2" /><rect className="border" x={1} y={1} width={20} height={20} rx={1} stroke="#CCCCCC" /></svg>;
export default SvgCheckboxIndeterminate;